// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * How the UI dispatches a control command that targets a floor.
 *
 * The two surfaces that send positional commands disagreed by accident: the
 * Car Calls pad sends on the first floor-button click, while an Actions card
 * stages the floor and waits for a second press on the command itself. One is
 * faster, the other is safer, and which one a site wants is a property of the
 * site — so it is configuration rather than a constant.
 *
 * Resolution is two-level: a USER carries INHERIT unless an administrator has
 * set an explicit override, and INHERIT means "use the organization's value".
 * An ORGANIZATION never stores INHERIT; there is nothing above it to inherit
 * from, and TWO_STEP is its default because it is the behaviour that cannot
 * send a command at a floor nobody chose.
 *
 * INHERIT is deliberately 0 so an unset user reads as inheriting rather than
 * as an explicit choice. Values are APPEND-ONLY.
 */
export enum ActionFiringMode {
  /**
   * Take the effective value from the organization. USER-level only.
   */
  INHERIT = 0,

  /**
   * Selecting a floor stages it; sending needs a second, explicit press.
   */
  TWO_STEP = 1,

  /**
   * The floor button is the send.
   */
  ONE_CLICK = 2,
}
